export const metrics = {
    totalStudents: 1254,
    activeCourses: 48,
    avgCompletionRate: 78.5,
    studentEngagement: 85.2,
};

export const courseEnrollmentData = [
    { month: "Jan", enrollments: 150 },
    { month: "Feb", enrollments: 180 },
    { month: "Mar", enrollments: 210 },
    { month: "Apr", enrollments: 190 },
    { month: "May", enrollments: 250 },
    { month: "Jun", enrollments: 280 },
    { month: "Jul", enrollments: 320 },
];

export const studentActivityData = [
    { name: "Mon", active: 420 },
    { name: "Tue", active: 480 },
    { name: "Wed", active: 550 },
    { name: "Thu", active: 580 },
    { name: "Fri", active: 480 },
    { name: "Sat", active: 340 },
    { name: "Sun", active: 280 },
];

export const courseDistributionData = {
    data: [
        { name: "Programming", value: 35 },
        { name: "Design", value: 25 },
        { name: "Business", value: 20 },
        { name: "Other", value: 20 },
    ],
    colors: ["#4CAF50", "#FF5722", "#2196F3", "#9E9E9E"],
};
